import { type FC, type RefObject } from "react";
import { Icon } from "@root/shared/components/Icon";
import { DayPicker } from "react-day-picker";
/* eslint-disable import/no-duplicates */
import { ja } from "date-fns/locale";
import { format } from "date-fns";
/* eslint-enable */
import * as styles from "./styles.css";
import "react-day-picker/dist/style.css";
import { type CalendarProps } from "./type";

type Props = {
  isShow: boolean;
  showCalendar: () => void;
  outerRef: RefObject<HTMLDivElement>;
} & CalendarProps;

export const Presentation: FC<Props> = ({
  selectedDate,
  handleOnSelect,
  isShow,
  showCalendar,
  outerRef,
  placeholder,
  hasError,
  isDisabled,
  startDate,
  endDate,
  disabledDate,
  name,
}) => {
  return (
    <div className={styles.outer} ref={outerRef}>
      <input
        type="text"
        value={selectedDate ? `${format(selectedDate, "yyyy年MM月dd日", { locale: ja })}` : ""}
        onFocus={showCalendar}
        className={styles.input({ hasError, isDisabled })}
        readOnly
        disabled={isDisabled}
        placeholder={placeholder}
        name={name}
      />
      <span className={styles.iconOuter}>
        <Icon name="calendar-check" />
      </span>
      {isShow && (
        <div className={styles.calendarOuter}>
          <DayPicker
            mode="single"
            selected={selectedDate}
            onSelect={handleOnSelect}
            locale={ja}
            captionLayout="dropdown"
            disabled={disabledDate}
            fromDate={startDate}
            toDate={endDate}
          />
        </div>
      )}
    </div>
  );
};
